import { render } from "./TrackReport.vue?vue&type=template&id=4fed52d9"
import script from "./TrackReport.vue?vue&type=script&lang=js"
export * from "./TrackReport.vue?vue&type=script&lang=js"
script.render = render

export default script